// extracted by mini-css-extract-plugin
module.exports = {"button":"StyledButton_button__3InlK","icon":"StyledButton_icon__2D-au","text":"StyledButton_text__3B2uK"};